import { useState, useEffect } from "react";
import DistributorNavbar from "./DistributorComp/DistributorNavbar";
import DataTable from "react-data-table-component";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import Swal from "sweetalert2";
import * as XLSX from "xlsx"; // Import xlsx for Excel export
import { Link } from "react-router-dom";
import PinRequestByAgent from "./PinRequestByAgent";

function RequestAgent() {
  const [filterText, setFilterText] = useState("");
  const [transactions, setTransactions] = useState([]);  
  const [walletBalance, setWalletBalance] = useState(0);  

  const distributorId = localStorage.getItem("distributor_id");
  
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${baseurl}AllRequestByAgent/${distributorId}`);
        setTransactions(response.data.transactions || []);
        // setWalletBalance(parseFloat(response.data.wallet_balance) || 0);
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setTransactions([]);
      }
    };

    fetchTransactions();
  }, [distributorId]);


  useEffect(() => {
    const fetchWalletBalance = async () => {
      try {
        const response = await axios.get(`${baseurl}GetWalletTransactions/${distributorId}`);
        setWalletBalance(parseFloat(response.data.wallet_balance) || 0);
      } catch (error) {
        console.error("Error fetching wallet balance:", error);
        setWalletBalance(0); // Ensure it's always a number
      }
      setIsFetching(false);
    };
  
    fetchWalletBalance();
  }, [distributorId]);
  

  // Handle Grant Request action
  const handleGrantRequest = async (transactionId, amount) => {
    if (walletBalance >= amount) {
      try {
        console.log("Sending data:", { transactionId, distributorId }); // Log before sending
  
        const response = await axios.post(`${baseurl}GrantTopUpRequest`, {
          transactionId,
          distributorId
        });
  
        console.log("Response received:", response.data); // Log backend response
  
        if (response.data.success) {
          Swal.fire("Success", "Request granted successfully!", "success");
          setWalletBalance(walletBalance - amount);
        } else {
          Swal.fire("Error", "Failed to grant request.", "error");
        }
      } catch (error) {
        console.error("Error during request:", error); // Log the full error object
        Swal.fire("Error", "Something went wrong.", "error");
      }
    } else {
      Swal.fire("Insufficient Balance", "Please add more funds.", "warning");
    }
  };
  
  // Columns for the DataTable
  const columns = [
    { name: "Sr. No.", selector: (row, index) => index + 1, sortable: false, width: "80px" },
    { name: "Amount", selector: (row) => `₹${row.amount}`, sortable: true },
    { name: "Transaction Type", selector: (row) => row.transaction_type, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true, width: "120px" },
    {
      name: "Transaction Detail",
      selector: (row) => row.transaction_reason,
      sortable: true,
      cell: (row) => (
        <div className="reason-column text-start">{row.transaction_reason}</div>
      ),
      width: "300px",
    },
    { name: "Date", selector: (row) => new Date(row.created_at).toLocaleDateString(), sortable: true },
    {
      name: "Grant Request",
      cell: (row) =>
        walletBalance >= row.amount ? (
          <button
            className="btn3 btn-success text-white"
            onClick={() => handleGrantRequest(row.id, row.amount)}
          >
            Grant Request
          </button>
        ) : (
          <Link to="/state-head/my-wallet" className="btn3 btn-warning text-white">
            Add Funds
          </Link>
        ),
      width: "180px",
    },
  ];

  const filteredTransactions = transactions.filter(
    (transaction) =>
      transaction.transaction_reason.toLowerCase().includes(filterText.toLowerCase()) ||
      transaction.transaction_type.toLowerCase().includes(filterText.toLowerCase()) ||
      transaction.status.toLowerCase().includes(filterText.toLowerCase())
  );

  // 📥 Function to Export DataTable as Excel
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(transactions.map((row, index) => ({
      "Sr. No.": index + 1,
      "Amount": row.amount,
      "Transaction Type": row.transaction_type,
      "Status": row.status,
      "Transaction Detail": row.transaction_reason,
      "Date": new Date(row.created_at).toLocaleDateString(),
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Wallet Transactions");

    XLSX.writeFile(wb, "Wallet_Transactions.xlsx");
  };

  return (
    <>
      <DistributorNavbar />
      <div className="bgagent transaction-container">
        <div className="container-fluid">
          <div className="row g-2 mb-3">
            <div className="col-md-3">
              <div className="bg-white p-3 border rounded">
                <h2 className="title text-start">Wallet Balance</h2>
                <div className="kma2 text-start">&#8377; {walletBalance.toFixed(2)}</div>
              </div>
            </div>
          </div>

          <div className="crdmain">
            <div className="transaction-card">
              <h2 className="title text-start">Pending Top Up Request</h2>

              <input
                type="text"
                className="search-box"
                placeholder="Search transactions..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />

              <DataTable
                columns={columns}
                data={filteredTransactions}
                pagination
                highlightOnHover
                striped
                noDataComponent="No transactions found"
                className="transaction-table"
              />

              <button className="btn btn-primary mt-3" onClick={handleDownloadExcel}>
                📥 Download Excel
              </button>
            </div>
          </div>
        </div>




 


      </div>
    </>
  );
}

export default RequestAgent;
